import type {NodePojo} from '@packages/systems/core/nodepojo';

/**
 * Recursively collects a node and all its descendants in a flat array.
 * Used for traversing abstract node POJO trees (e.g., rich text content).
 *
 * @param nodePojo - The abstract node to collect from
 * @returns A flat array containing the node and all its descendants
 */
export function collectChildrenAndNode(nodePojo: NodePojo): NodePojo[] {
  return [
    nodePojo,
    ...(nodePojo.children?.flatMap(collectChildrenAndNode) ?? []),
  ];
}
